/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DocsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Serve Html
     * @returns string Successful Response
     * @throws ApiError
     */
    public serveHtmlOverviewGet(): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/overview/',
        });
    }
}
